import React from 'react';
import { Helmet } from 'react-helmet-async';
import GoogleReviewsWidget from '@/components/common/GoogleReviewsWidget';

const Testimonials = () => {
  // Review aggregate schema for SEO
  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Fort Worth Dental",
    "image": "https://fortworthdental.com/logo-fwd.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "4620 Citylake Blvd W",
      "addressLocality": "Fort Worth",
      "addressRegion": "TX",
      "postalCode": "76132",
      "addressCountry": "US"
    },
    "telephone": "(817) 985-3337",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1105",
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Patient Reviews &amp; Testimonials | Fort Worth Dental | 4.9 Star Rating</title>
        <meta name="description" content="Read 1,100+ patient reviews and testimonials for Fort Worth Dental. 4.9 star rating on Google. See why patients choose Dr. Mund and Dr. Razo for dental implants, Invisalign, and family dentistry in Fort Worth TX." />
        <meta name="keywords" content="fort worth dental reviews, dentist reviews fort worth tx, best dentist reviews, dental implant reviews, invisalign reviews fort worth, patient testimonials" />
        <link rel="canonical" href="https://fortworthdental.com/testimonials" />
        <script type="application/ld+json">{JSON.stringify(reviewSchema)}</script>
      </Helmet>
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-teal-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Patient Testimonials</h1>
          <p className="text-xl max-w-3xl mx-auto">
            See what our patients are saying about their experience at Fort Worth Dental
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          
          {/* Google Reviews Widget */}
          <GoogleReviewsWidget variant="full" maxReviews={6} />

          {/* Leave a Review CTA */}
          <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 text-white p-12 rounded-lg text-center">
            <h2 className="text-3xl font-bold mb-4">Had a Great Experience?</h2>
            <p className="text-xl mb-8">
              We&apos;d love to hear from you! Share your experience with Fort Worth Dental
            </p>
            <a
              href="https://g.page/r/CUolB0PBcru6EBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition"
            >
              Leave a Google Review
            </a>
          </div>

          {/* Why Reviews Matter */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white p-8 rounded-xl shadow-md">
              <div className="text-5xl mb-4">🏆</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Award-Winning Care</h3>
              <p className="text-gray-600">
                Recognized as Best Dentist Office by Fort Worth Magazine multiple years
              </p>
            </div>
            <div className="text-center bg-white p-8 rounded-xl shadow-md">
              <div className="text-5xl mb-4">😊</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Patient-Focused</h3>
              <p className="text-gray-600">
                Our top priority is ensuring your comfort and satisfaction
              </p>
            </div>
            <div className="text-center bg-white p-8 rounded-xl shadow-md">
              <div className="text-5xl mb-4">👨‍⚕️</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Expert Team</h3>
              <p className="text-gray-600">
                Experienced doctors and staff dedicated to your dental health
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Ready to Experience the Fort Worth Dental Difference?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Schedule your appointment today and see why our patients love us!
            </p>
            <a
              href="tel:8179853337"
              className="inline-block bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-teal-700 transition"
            >
              Call (817) 985-3337
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Testimonials;
